var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chevron-down-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_1",
    transform: "translate(-818.000000, -929.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(580.000000, 916.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-outline",
    transform: "translate(249.000000, 24.000000) scale(1, -1) translate(-249.000000, -24.000000) translate(238.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,14.2083487 C10.7563473,14.209742 10.5221589,14.1140876 10.3491667,13.9425 L6.6825,10.2758333 C6.44997963,10.043313 6.35917009,9.70440717 6.44427844,9.38677846 C6.5293868,9.06914974 6.77748307,8.82105347 7.09511179,8.73594511 C7.41274051,8.65083676 7.75164631,8.7416463 7.98416667,8.97416667 L11,12.0083333 L14.025,9.09333333 C14.2548643,8.8377365 14.6084106,8.73222885 14.940759,8.82004641 C15.2731073,8.90786398 15.5283884,9.17424424 15.6019904,9.51002704 C15.6755924,9.84580985 15.5551426,10.1945486 15.29,10.4133333 L11.6233333,13.9516667 C11.4556978,14.1132888 11.2328361,14.2050554 11,14.2083487 L11,14.2083487 Z",
    id: "Path",
    fill: "#1D2B7D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.7bc34a6f2c82a0dc6b1425f57fb406ef.svg";
export { ForwardRef as ReactComponent };